import { render, staticRenderFns } from "./HoldingFunds.vue?vue&type=template&id=a56cdcb8&scoped=true&"
import script from "./HoldingFunds.vue?vue&type=script&lang=js&"
export * from "./HoldingFunds.vue?vue&type=script&lang=js&"
import style0 from "./HoldingFunds.vue?vue&type=style&index=0&id=a56cdcb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56cdcb8",
  null
  
)

export default component.exports